module.exports = __webpack_public_path__ + "static/media/AIML.e4ff27fb.avif";